"use strict";

var profileSDK = require('@nackle/profile-sdk');

var _require = require('../utils/endpoints'),
    profileUrl = _require.profileUrl;

var _require2 = require('../utils/error'),
    throwServiceError = _require2.throwServiceError;

var SERVICE_NAME = 'profile';

module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = new profileSDK(profileUrl, fetch);

  function getAvatar(personId) {
    return new Promise(function ($return, $error) {
      var response;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getImage');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(sdk.getAvatar(personId)).then(function ($await_2) {
          try {
            response = $await_2;

            if (response && response.imageUrl) {
              return $return(response.imageUrl);
            }

            return $return(null);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  }

  return {
    getAvatar: getAvatar
  };
};
//# sourceMappingURL=profile.js.map